<script lang="ts" context="module">
  export const paidModal = new ModalQueryState('paid');
</script>

<script lang="ts">
  import ActionButton from '~/components/ActionButton.svelte';
  import Modal from '~/components/Modal.svelte';
  import Premium from '~/icons/Premium.svelte';
  import Close from '~icons/mdi/close';
  import { ModalQueryState } from '#lib/nav.svelte.js';
  import PremiumOverview from './PremiumOverview.svelte';
  import StatusText from '~/components/StatusText.svelte';
  import AuthButton from './AuthButton.svelte';
  import { getSubscriptionQuery } from './mutations.svelte';
  import { getTrialText } from './utils';

  const sub = getSubscriptionQuery();

  const onClose = () => {
    paidModal.pop();
  };
</script>

<Modal index={4} open={paidModal.open} {onClose}>
  {#snippet title()}
    <Premium />
    Thank you for your support!
  {/snippet}
  {#snippet content()}
    {#if sub.data?.status === 'active'}
      <StatusText status="success">You are a Premium user now!</StatusText>
    {:else if sub.data?.status === 'trialing'}
      <StatusText status="warn">
        {getTrialText(sub.data)}
      </StatusText>
    {/if}
    <p>You can manage your subscription via account settings</p>
    <AuthButton />
    <PremiumOverview hideSupport />
  {/snippet}
  {#snippet controls()}
    <ActionButton onClick={onClose}>
      <Close />
      CLOSE
    </ActionButton>
  {/snippet}
</Modal>
